import { logger, ELogEnvironment } from 'Common/utils/logger/logger';
export class APIError extends Error {
    constructor(message) {
        const errorMessage = `[API Error] ${message !== null && message !== void 0 ? message : 'Unknown error'}`;
        super(errorMessage);
        logger.error(errorMessage, ELogEnvironment.All);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
